import * as yup from "yup";
import { enums } from "../constants/enum";

const objectIdSchema = yup
  .string()
  .trim()
  .matches(/^[0-9a-fA-F]{24}$/, "Must be a valid ID");

export const supplySchema = yup.object({
  supplier: objectIdSchema.required("Supplier ID is required"),
  items: yup
    .array()
    .of(
      yup.object({
        item: objectIdSchema.required("Item ID is required"),
        quantity: yup
          .number()
          .typeError("Quantity must be a number")
          .integer("Quantity must be an integer")
          .min(1, "Quantity must be at least 1")
          .required("Quantity is required"),
      }),
    )
    .min(1, "At least one item is required")
    .required("At least one item is required"),
  payments: yup
    .array()
    .of(
      yup.object({
        amount: yup
          .number()
          .typeError("Amount must be a number")
          .min(0.01, "Amount must be a positive number")
          .required("Payment amount is required"),
        date: yup.date().default(() => new Date()),
        method: yup
          .string()
          .oneOf(Object.values(enums.PAYMENT_METHODS), "Invalid payment method")
          .required("Payment method is required"),
        paymentSlip: objectIdSchema.nullable().notRequired(),
        chequeNumber: yup.string().when("method", {
          is: enums.PAYMENT_METHODS.CHEQUE,
          then: (schema) =>
            schema.required("Cheque number is required for CHEQUE payments"),
          otherwise: (schema) => schema.notRequired(),
        }),
      }),
    )
    .optional(),
});

export const updateSupplySchema = yup.object({
  supplier: objectIdSchema.required("Supplier ID is required"),
  items: yup
    .array()
    .of(
      yup.object({
        item: objectIdSchema.required("Item ID is required"),
        quantity: yup
          .number()
          .typeError("Quantity must be a number")
          .integer("Quantity must be an integer")
          .min(1, "Quantity must be at least 1")
          .required("Quantity is required"),
      }),
    )
    .min(1, "At least one item is required")
    .required("At least one item is required"),
});

export const paymentSchema = yup.object({
  amount: yup
    .number()
    .typeError("Amount must be a number")
    .min(0.01, "Amount must be a positive number")
    .required("Payment amount is required"),
  date: yup
    .date()
    .typeError("Date must be in ISO format")
    .required("Payment date is required"),
  method: yup
    .string()
    .oneOf(Object.values(enums.PAYMENT_METHODS), "Invalid payment method")
    .required("Payment method is required"),
  paymentSlip: objectIdSchema.required("Payment Slip ID is required"),
  chequeNumber: yup.string().when("method", {
    is: enums.PAYMENT_METHODS.CHEQUE,
    then: (schema) =>
      schema.required("Cheque number is required for CHEQUE payments"),
    otherwise: (schema) => schema.optional(), 
  }),
});
